import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  getAllLeaves,
  approveOrRejectLeave,
  deleteLeaveRequest,
} from "app/redux/actions";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
  IconButton,
  Tooltip,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Pagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { Breadcrumb, SimpleCard } from "app/components";
import Loading from "app/components/MatxLoading";
import { PAGE_LIMIT } from "../../../config";
import { capitalizeFirstLetter } from "app/assets/genericActions";
import styled from "styled-components";


const HorizontalTable = styled.div`
      overflow-x: auto;
    
      @media (max-width: 600px) {
      width: 260%;
      overflow-x: auto;
      }
    `;
const AllMyRequests = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loggedInUser = useSelector((state) => state.user.user);
  const { leaves, loading, totalPages } = useSelector((state) => state.leave);
  const [dialogOpen, setDialogOpen] = useState(false);

  const [employeeToDelete, setEmployeeToDelete] = useState(null);


  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState({
    userId: loggedInUser.id,
    status: "",
    leaveType: "",
  });



  useEffect(() => {
    dispatch(getAllLeaves({ ...filters, page, limit: PAGE_LIMIT }));
  }, [dispatch, filters, page]);

  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    setPage(1);
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };



  const handleEdit = (id) => {
    navigate(`/edit-request/${id}`);
  };

  const handleDelete = (id) => {
    // if (window.confirm("Are you sure you want to delete this leave request?")) {
    //   dispatch(deleteLeaveRequest(id))
    //     .then(() => {
    //       toast.success("Leave request deleted successfully.");
    //       if (leaves.length === 1 && page > 1) {
    //         setPage(page - 1);
    //       } else {
    //         dispatch(getAllLeaves({ ...filters, page, limit: PAGE_LIMIT }));
    //       }
    //     })
    //     .catch((err) => {
    //       toast.error("Failed to delete request.");
    //       console.error("Delete failed:", err);
    //     });
    // }
    setEmployeeToDelete(id);
    setDialogOpen(true);
  };
  const handleDialogClose = () => {
    setDialogOpen(false);
    setEmployeeToDelete(null);
  };

  const confirmDelete = () => {
    dispatch(deleteLeaveRequest(employeeToDelete));
    setDialogOpen(false);
    setEmployeeToDelete(null);
    toast.success("Leave Request Deleted Successfully!")
  };
  if (loading && (!leaves || leaves.length === 0)) {
    return <Loading />;
  }

  return (
    <SimpleCard
      sx={{ display: "flex", flexDirection: "column", height: "100%" }}
    >

      <Box sx={{ flexGrow: 1, overflowY: "auto", p: { xs: 2, md: 3 } }}>
        <Box sx={{ mb: 2 }}>
          <Breadcrumb routeSegments={[{ name: "All Leave Requests" }]} />
        </Box>

        <Grid container spacing={2} sx={{ mb: 2 }}>


          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel>Filter by Type</InputLabel>
              <Select
                name="leaveType"
                value={filters.leaveType}
                onChange={handleFilterChange}
                label="Filter by Type"
              >
                <MenuItem value="">
                  <em>All</em>
                </MenuItem>
                <MenuItem value="Sick">Sick</MenuItem>
                <MenuItem value="Casual">Casual</MenuItem>
                <MenuItem value="Urgent">Urgent</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel>Filter by Status</InputLabel>
              <Select
                name="status"
                value={filters.status}
                onChange={handleFilterChange}
                label="Filter by Status"
              >
                <MenuItem value="">
                  <em>All</em>
                </MenuItem>
                <MenuItem value="Pending">Pending</MenuItem>
                <MenuItem value="Approved">Approved</MenuItem>
                <MenuItem value="Rejected">Rejected</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Box sx={{ flexGrow: 1, overflow: 'auto', paddingBottom: '70px' }}>
          <HorizontalTable>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ pl: 4 }}>Employee Name</TableCell>
                    <TableCell>Dates</TableCell>
                    <TableCell>Leave Type</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Approver</TableCell>
                    <TableCell align="center">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {leaves && leaves.length > 0 ? (
                    leaves.map((leave) => {

                      const canEditOrDelete = leave.status === "Pending";

                      return (
                        <TableRow key={leave.id}>
                          <TableCell sx={{ pl: 4 }}>
                            {leave.employee ? capitalizeFirstLetter(leave.employee.name) : "N/A"}
                          </TableCell>
                          <TableCell>
                            {new Date(leave.startDate).toLocaleDateString()} -{" "}
                            {new Date(leave.endDate).toLocaleDateString()}
                          </TableCell>
                          <TableCell>{leave.leaveType}</TableCell>
                          <TableCell>{leave.status}</TableCell>
                          <TableCell>
                            {leave?.approver
                              ? `${leave?.approver?.name} (${leave?.approver?.userType})`
                              : ""}
                          </TableCell>
                          <TableCell align="center">
                            {canEditOrDelete && (
                              <>
                                <Tooltip title="Edit">
                                  <IconButton onClick={() => handleEdit(leave.id)}>
                                    <EditIcon />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Delete">
                                  <IconButton
                                    onClick={() => handleDelete(leave.id)}
                                  >
                                    <DeleteIcon color="error" />
                                  </IconButton>
                                </Tooltip>
                              </>
                            )}

                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        <Typography>
                          No leave requests found for the selected filters.
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </HorizontalTable>
        </Box>
      </Box>

      {leaves && leaves.length > 0 && (
        <Box
          display="flex"
          justifyContent="center"
          sx={{
            py: 2,
            backgroundColor: "background.paper",
            boxShadow: "0 -2px 5px rgba(0,0,0,0.1)",
          }}
        >
          <Pagination
            count={totalPages || 1}
            page={page}
            onChange={handlePageChange}
            color="primary"
          />
        </Box>
      )}
      <Dialog open={dialogOpen} onClose={handleDialogClose}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this employee?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmDelete} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </SimpleCard>
  );
};

export default AllMyRequests;
